import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-resources-list',
  imports: [CommonModule],
  templateUrl: './resources-list.component.html',
  styleUrl: './resources-list.component.scss'
})
export class ResourcesListComponent implements OnInit {

  @Input() heading: string = 'Resources:'
  @Input() titlesList!: string[][]

  constructor(){
    
  }
  ngOnInit() {

    console.log(this.titlesList[0][0]);

  }
}
